module.exports = __webpack_public_path__ + "img/about_bg2.6cf1d459.png";